import { Box, Stack, useTheme } from "@mui/material";

import type { ReactNode } from "react";

export default function ScrollPanel({ children }: { children: ReactNode }) {
  const theme = useTheme();
  return (
    <Stack
      direction="column"
      sx={{
        bgcolor: theme.palette.background["paper-elevation-1"],
        flex: 1,
        overflowY: "auto",
        minHeight: 0,
      }}
    >
      <Box sx={{ paddingY: 5 }}>{children}</Box>
    </Stack>
  );
}
